
export default {
    props: {
        filterList: {
            type: Array,
            default: ()=>[]
        },
        typeSlug: {
            type: String,
            default: undefined,
        },
        route: {
            type: String,
            default: undefined,
        },
        isTaxonomy: Boolean
    },
    computed: {
        taxonomy() {
            return this.$route.params?.taxonomy
        },
    },

    data() {
        return {
            defaultImage: '/whimsical.png',
        }
    },

    methods: {

        getImage(model) {
            if(this.isTaxonomy){
                try {
                    if (model?.metas?.card_image) {
                        const a = JSON.parse(model.metas.card_image)
                        if (a && a.id) return `${process.env.apiUrl}/api/v1/attachments/64/64/${a.id}`
                    }
                } catch (e) {}
                return this.defaultImage
            }
            return model?.list_image?.url || this.defaultImage
        },

        getColor(model) {
            const img = this.getImage(model)
            if (img === this.defaultImage)
                if (model?.metas && model.metas.color)
                    return model.metas.color
            return undefined
        }
    }
}
